import React, { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';

const ImageUploader = ({
  label,
  image,
  setImage,
}: {
  label?: string;
  image: string;
  setImage: (url: string) => void;
}) => {
  const [isUploading, setIsUploading] = useState(false);

  const upload = useCallback(
    async (files: File[]) => {
      const uploadURL = `${process.env.REACT_APP_API_BASE_URL}/media/upload`;

      try {
        setIsUploading(true);
        await Promise.all(
          files.map(async (file) => {
            const fd = new FormData();
            fd.append('file', file);
            setIsUploading(true);

            const response = await fetch(uploadURL, {
              method: 'POST',
              body: fd,
            });

            const result = await response.json();
            const { url } = result;
            return Promise.resolve(url);
          }),
        )
          .then((urls) => {
            setImage(urls[0]);
            setIsUploading(false);
          })
          .finally(() => setIsUploading(false));
      } catch (error) {
      } finally {
        setIsUploading(false);
      }
    },
    [setImage, setIsUploading],
  );

  const onDrop = (acceptedFiles: File[]) => {
    const file = acceptedFiles[0];
    if (file) {
      upload([file]);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/*',
    multiple: false,
  });

  return (
    <div className="flex flex-col">
      {label && <label className="mb-2 text-[#202223] text-sm">{label}</label>}
      <div
        {...getRootProps()}
        className="w-full max-w-md h-40 border-2 border-dashed border-[#c9cccf] rounded-md flex flex-col justify-center items-center cursor-pointer hover:border-[#2563EB] transition-all bg-[#fafbfb]"
      >
        <input {...getInputProps()} />
        {image ? (
          <div className="relative w-full h-full p-4">
            <img
              src={image}
              alt="Preview"
              className="w-full h-full object-contain rounded"
            />
          </div>
        ) : (
          <div className="text-center px-4">
            <p className="text-[#6d7175] text-sm mb-1">
              Click or drag and drop to upload
            </p>
            <p className="text-[#8c9196] text-xs">PNG, JPG, GIF up to 10MB</p>
          </div>
        )}
        {isUploading && (
          <p className="text-sm text-[#6d7175] my-2">
            Uploading, please wait...
          </p>
        )}
      </div>
    </div>
  );
};

export default ImageUploader;
